import { useApi, useMount } from "hooks";
import React, { useRef } from "react";
import lang from "translations";
import ResourceForm from "../resource-form/resource-form";
import { createResource } from "apis";
import { resourceRequest } from "mappers";
import { mixpanel, TrackEvent } from "mixpanel";

const CreateResource = () => {
  const { request, loading: submitting } = useApi({
    api: createResource,
    handleOwnError: {
      badrequest: true,
    },
    paramsMapper: resourceRequest,
  });

  // Use React ref to persist last used values in memory (not localStorage)
  const lastUsedRef = useRef({});

  // Only prefill certain fields
  const getInitialState = () => {
    const last = lastUsedRef.current;
    if (!last) return undefined;
    const {
      capacity,
      allowWalkIn,
      locationId,
      resourceTypeId,
      resourceStatusId,
    } = last;
    return {
      capacity,
      allowWalkIn,
      locationId,
      resourceTypeId,
      resourceStatusId,
    };
  };

  useMount(() => {
    mixpanel.track(TrackEvent.VisitedPage, {
      Page: lang.createResource,
    });
  });

  const submitForm = React.useCallback(
    async (params) => {
      try {
        // Save selected fields to ref for next create
        lastUsedRef.current = {
          capacity: params.capacity,
          allowWalkIn: params.allowWalkIn,
          locationId: params.locationId,
          resourceTypeId: params.resourceTypeId,
          resourceStatusId: params.resourceStatusId,
        };

        const res = await request(params);
        return {
          response: res,
          message: lang.populate(lang.resourceCreated, [params.customName]),
        };
      } catch (e) {
        throw e;
      }
    },
    [request]
  );

  return (
    <ResourceForm
      submit={submitForm}
      title={lang.createNewResource}
      submitting={submitting}
      initialState={getInitialState()}
    />
  );
};

export default CreateResource;
